enum INTAKE_TYPES {
  ADD_PET = 'add_pet',
  ADD_TRANSPORT_ANIMAL = 'add_transport_animal',
  BOARDING_IN = 'boarding_in',
  BORN_IN_CARE = 'born_in_care',
  CLINIC_IN = 'clinic_in',
  DOA = 'doa',
  FOUND = 'found',
  LOST = 'lost',
  OWNER_REQUESTED_EUTHANASIA = 'owner_requested_euthanasia',
  OWNER_SURRENDER = 'owner_surrender',
  RETURN = 'return',
  SEIZED = 'seized',
  SERVICE_IN = 'service_in',
  STRAY = 'stray',
  TRANSFER_IN = 'transfer_in',
  UNKNOWN = 'unknown',
  WILDLIFE_IN = 'wildlife_in',
}

export { INTAKE_TYPES };
